











































































import {Vue, Component} from 'vue-property-decorator'
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import {mixins} from "vue-class-component";

@Component({})
export default class TrgovinskiLanci extends mixins(ComponentBaseMixin) {
  isBusySave = false;
  trgovinskiLanci = [];
  trgovinskiLanac = {id: 0, code: '', publicId: '', name: ''};
  columns = [];
  tableOptions = {
    pagination: true,
    onClickRow: row => this.onClickRow(row)
  };

  async created() {
    this.columns = [
      {field: 'code', sortable: true, title: this.$i18n.t('kod')},
      {field: 'name', sortable: true, title: this.$i18n.t('naziv')}
    ];
  }

  mounted() {
    (<any>this.$refs.observer).validate();
    this.ucitajTrgovinskeLance();
  }

  async ucitajTrgovinskeLance() {
    this.trgovinskiLanci = [];
    let table = $('#chainsTable');
    try {
      table.bootstrapTable('showLoading');
      const {data} = await this.axios.get('api/GetRetailChains');
      this.trgovinskiLanci = data;
    } catch (err) {
      table.bootstrapTable('hideLoading');
      this.showError('greskaPrilikomUcitavanja');
    } finally {
      table.bootstrapTable('hideLoading');
    }
  }

  onClickRow(row) {
    this.trgovinskiLanac = row;
  }

  noviTrgovinskiLanac() {
    this.trgovinskiLanac = {id: 0, code: '', publicId: '', name: ''};
  }

  async sacuvajTrgovinskiLanac() {
    const valid = await (<any>this.$refs.observer).validate();
    if (valid) {
      try {
        this.isBusySave = true;
        const {data} = await this.axios.post('api/SaveRetailChain', this.trgovinskiLanac);
        this.trgovinskiLanac.id = data.id;
        await this.ucitajTrgovinskeLance();
        this.showInfo('podaciUspesnoSacuvani');
      } catch (err) {
        this.isBusySave = false;
        this.showError('neuspesnoCuvanjePodataka');
      } finally {
        this.isBusySave = false;
      }
    } else {
      this.showInfo('nisu sva obavezna polja popunjena');
    }
  }

}
